import { PerfilEnum } from '../enum/perfil';

export class Comunicado {

    constructor(
        public id?: string,
        public titulo?: string,
        public resumo?: string,
        public corpo?: string,
        public dataCriacao?: Date,
        public dataPublicacao?: Date,
        public lido?: boolean,
        public perfis?: Array<string>,
        public requerConfirmacao?: boolean,
        public usuarios?: Array<string>,
        public importante?: boolean,
        public deAcordo?: boolean,
        public geral?: boolean,
        public imagem?
    ){
    	this.perfis = [];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/comunicado.ts